import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useUser, SignedOut} from '@clerk/clerk-react';
import AnonymousWelcome from '@/components/AnonymousWelcome';
import Loading from '@/components/Loading';

interface IndexSearchParams {
  redirectUrl?: string;
}

// URL search string parameter re is an optional redirect URL to return to 
// after sign-in/sign-up.
const extractRedirectUrl = (search?: Record<string,unknown>): string | undefined => {
  if (search?.hasOwnProperty("re")) {
    return search.re as string;
  }
}

export const Route = createFileRoute('/')({
  component: RouteComponent,
  validateSearch: (search: Record<string,unknown>): IndexSearchParams => {
    return {
      redirectUrl: extractRedirectUrl(search)
    }
  }
})

const logRoute = () => {
  console.log("Index route");
}

function RouteComponent() {
  const { isLoaded, isSignedIn } = useUser();
  const { redirectUrl } = Route.useSearch()

  const navigate = useNavigate();

  logRoute();

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      
      navigate({ to: '/home', viewTransition: true });
    }
  }, [isLoaded, isSignedIn]);
  
  if (!isLoaded) {
    return ( <Loading /> );
  }

  return (
    <div className="page-container">
      <SignedOut>
        <AnonymousWelcome redirect={redirectUrl} />
      </SignedOut>
    </div>
  );
}
 